module.exports = __webpack_public_path__ + "static/media/herobg_1x2.843f8bc8.jpg";